import { DataBean } from "../DataBean";

export class AccountHelpDesk extends DataBean {

    public ACTIVE = 1;
    public INACTIVO = 2;
    
     public async getAccountHelpDeskRender(page:number,rows:number,props:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.shared.Report_getAccountHelpDeskRender_Number_Number_java.util.Map", [
            page,rows,props
        ]);
    }
  
  
   
}
